module.exports = __webpack_public_path__ + "img/centennial - testimonial video - poster 2.94f1a7eb.jpg";